




































import { Component, Vue, Watch } from "vue-property-decorator";
import { readGitLabInfo } from "@/store/gitlab/getters";
import { api } from "@/api";
import {
  commitResetGitLab,
  commitSetGitLabInfo
} from "@/store/gitlab/mutations";
import SetBranch from "@/components/settings/SetBranch.vue";
import SetProject from "@/components/settings/SetProject.vue";
import { dispatchRaiseErrorTimeout } from "@/store/appState/actions";

@Component({
  components: { SetBranch, SetProject }
})
export default class GitLabSettings extends Vue {
  private gitLab = readGitLabInfo(this.$store);
  private loading = true;
  private updateCounter = 0;

  $refs!: {
    branch: SetBranch;
  };

  @Watch("updateCounter")
  private onUpdateCounter() {
    this.$refs.branch.initialize();
  }

  private async mounted() {
    try {
      const userInfo = await api.getCurrentUser();
      this.gitLab.authorName = userInfo.data.name;
      this.gitLab.authorEmail = userInfo.data.email;

      this.pushToStore();
    } catch (e) {
      dispatchRaiseErrorTimeout(
        this.$store,
        new Error(`Unable to fetch User Info:<br>${e}`)
      );
    }
    this.loading = false;
  }

  private pushToStore() {
    commitSetGitLabInfo(this.$store, this.gitLab);
  }

  private reset() {
    commitResetGitLab(this.$store);
    this.$router.go(0);
  }
}
